<template>
  <hm-content title="">
    <div class="temp-header flex flex-start mb10">
      <div @click="back" class="btn">
        <span class="hmicon icon-fanhui"></span>
        返回
      </div>
    </div>
    <!-- <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" class="mr10" @click="artificial"
          >人工充值</el-button
        >
        <el-button type="primary" size="small" @click="shenhe"
          >审核充值</el-button
        >
      </div>

      <div>
        <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="请选择审核状态"
          v-model="searchCondition.rechargeState"
        >
          <el-option label="待审核" value="wait"> </el-option>
          <el-option label="充值成功" value="yes"> </el-option>
          <el-option label="驳回" value="no"> </el-option>
        </el-select>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchCondition.applyDate"
          type="datetimerange"
          range-separator="至"
          start-placeholder="选择充值时间段"
          end-placeholder="选择充值时间段"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="searchs">查询</el-button>
        <el-button
          type="info"
          size="small"
          @click="output(searchCondition.status)"
          :loading="isOutputing"
          >导出报表</el-button
        >
      </div>
    </div> -->
    <div class="table">
      <el-table
        :data="companyRechargelist.records"
        style="width: 100%"
        ref="chongZhi"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          label="充值方式"
          prop="rechargeModes"
        >
          <template slot-scope="scope">
            {{ scope.row.rechargeMode === "wx_pay" ? "线上充值" : "线下充值" }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          header-align="center"
          align="center"
          label="审核状态"
          prop="rechargeState"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.rechargeMode === 'wx_pay'">
              <span
                class="status success"
                :class="scope.row.status"
                v-if="scope.row.rechargeState === 'yes'"
                >充值成功</span
              >
              <span
                class="status danger"
                v-if="scope.row.rechargeState === 'no'"
                >充值失败</span
              >
            </div>
            <div v-else>
              <span
                class="status success"
                :class="scope.row.status"
                v-show="scope.row.rechargeState === 'yes'"
                >充值成功</span
              >
              <span
                class="status blue"
                :class="scope.row.status"
                v-show="scope.row.rechargeState === 'wait'"
                >待审核</span
              >
              <span
                class="status danger"
                :class="scope.row.status"
                v-show="scope.row.rechargeState === 'no'"
                >驳回</span
              >
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          label="充值账户"
          prop="rechargeAccount"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="充值单号"
          prop="rechargeSn"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.rechargeSn }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="充值时间"
          prop="rechargeTime"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="rechargeMoney"
          label="充值金额"
        >
          <template slot-scope="scope">
            <div class="primary">¥{{ scope.row.rechargeMoney }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rechargeMoney"
          label="备注"
        >
          <template slot-scope="scope">
            {{
              scope.row.rechargeMode === "wx_pay" ? "" : scope.row.rechargeMode
            }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="充值人"
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="auditUsername"
          label="审核人"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditTime"
          label="审核时间"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.auditTime }}</div>
          </template>
        </el-table-column> -->
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                @click="pass(scope.row)"
                :disabled="
                  scope.row.rechargeState === 'yes' ||
                    scope.row.rechargeState === 'no'
                "
                >通过</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="reject(scope.row)"
                :disabled="
                  scope.row.rechargeState === 'yes' ||
                    scope.row.rechargeState === 'no'
                "
                >驳回</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="companyRechargelist.total"
          @current-change="pagingRecharge"
          @size-change="handleSizeChangeRecharge"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: mapGetters(["companyRechargelist"]),
  watch: {},
  created() {},
  mounted() {
    this.queryCompanyList();
  },
  methods: {
    pagingRecharge(page) {
      this.currentPage = page;
      this.queryCompanyList();
    },
    handleSizeChangeRecharge(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryCompanyList();
    },
    queryCompanyList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        rechargeState: "wait",
        storeCode: this.$route.query.storeCode
      };

      //   const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      //   searchCondition.rechargeTimeStart =
      //     this.searchCondition.applyDate &&
      //     this.searchCondition.applyDate.length > 0
      //       ? this.searchCondition.applyDate[0]
      //       : "";
      //   searchCondition.rechargeTimeEnd =
      //     this.searchCondition.applyDate &&
      //     this.searchCondition.applyDate.length > 0
      //       ? this.searchCondition.applyDate[1]
      //       : "";
      //   Object.assign(params, searchCondition);
      return this.$store.dispatch("queryCompanyRechargelist", params);
    },
    pass(row) {
      this.$confirm(`是否通过？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(res => {
          if (res === "confirm") {
            this.$store
              .dispatch("auditRechargeOrder", {
                rechargeId: row.rechargeId,
                rechargeState: "yes"
              })
              .then(res => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success"
                  });
                  this.queryCompanyList();
                }
              });
          }
        })
        .catch(() => {});
    },
    reject(row) {
      this.$confirm(`是否驳回？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(res => {
          if (res === "confirm") {
            this.$store
              .dispatch("auditRechargeOrder", {
                rechargeId: row.rechargeId,
                rechargeState: "no"
              })
              .then(res => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success"
                  });
                  this.queryCompanyList();
                }
              });
          }
        })
        .catch(() => {});
    },
    back() {
      this.$router.back(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.temp-header {
  //   height: 50px;
  //   line-height: 50px;
  cursor: pointer;
  background: rgba(255, 255, 255, 1);
  color: #000;
  //   padding: 0 22px;
  font-size: 16px;
  user-select: none;
  .hmicon {
    color: #e50065;
    font-size: 18px;
  }
}
</style>
